import React, {Fragment, useEffect, useState} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Popover, Switch, Divider, Collapse
} from "antd";

import {DownOutlined, DownloadOutlined, DeleteOutlined, PlusOutlined, InfoCircleOutlined} from '@ant-design/icons';

import ApiService from "../../services/ApiService"
import {MiddleSelect} from "antd/es/pagination/Select";
import IntlMessage from "../util-components/IntlMessage";
import TextArea from "antd/es/input/TextArea";
import {connect, useSelector} from "react-redux";
import ImageUploadField from "./ImageUpload";

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default function SeoPanelFields(props) {
    const lang = props.lang

    const org=useSelector(state => state.auth.org);


    return (
        <Collapse forceRender style={{marginBottom: 20}} defaultActiveKey={props.defaultOpen?0:undefined}>
            <Collapse.Panel forceRender header={"Personnalisation des liens (Whatsapp, Réseaux sociaux) | Référencement Web"} key={0}>

                <Form.Item
                    label={lang ? "Titre - (" + lang.label + ")" : "Titre"}
                    name={lang ? [lang.value, "metaTitle"] : "metaTitle"}
                >
                    <Input placeholder="Titre"/>
                </Form.Item>

                <Form.Item
                    label={lang ? "Description - (" + lang.label + ")" : "Description"}
                    name={lang ? [lang.value, "metaDescription"] : "metaDescription"}
                >
                    <TextArea placeholder="Description"/>
                </Form.Item>

                <Form.Item
                    label={lang ? "Image - (" + lang.label + ")" : "Image"}
                    name={lang ? [lang.value, "metaImage"] : "metaImage"}
                >
                    <ImageUploadField imageStyle={{maxHeight: 200}} maxSize={1024 * 300} text={"Max 300ko"}/>
                </Form.Item>

                {props.video && (
                    <Form.Item
                        label={lang ? "Video - (" + lang.label + ")" : "Video"}
                        name={lang ? [lang.value, "metaVideo"] : "metaVideo"}
                    >
                        <Input type={"url"} placeholder="Url de la video"/>
                    </Form.Item>
                )}

            </Collapse.Panel>
        </Collapse>
    )

}